module.exports = __webpack_public_path__ + "img/30.2f2857e4.jpg";